<template>
    <div>
        <div class="flex-col items-stretch hidden space-y-2 md:flex md:items-center justify-stretch lg:space-x-3 sm:flex-row sm:space-x-2 sm:space-y-0">
            <button
                v-if="isFavoriteable"
                @click="toggleFavorite"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-8 h-8"
                    :class="{'text-yellow-500 fill-current stroke-0': modelIsFavorite, 'text-gray-300 hover:text-yellow-500': !modelIsFavorite}"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="1"
                >
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                </svg>
            </button>
            <a
            v-if="canAddNotes"
                @click="addNote"
                href="#notes_files"
                class="tw-simple-button"
                role="menuitem"
            >Add Note</a>
            <a
                v-if="canAddToProject"
                @click="showModal"
                class="tw-simple-button"
                role="menuitem"
                style="margin-bottom: 0px;"
            >Add to Project</a>
            <a
                v-if="canEdit && editRoute"
                :href="editRoute"
                class="tw-simple-button"
                role="menuitem"
            >Edit</a>
            <a
                v-if="hasSimilarity"
                :href="similarityRoute"
                class="text-xs tw-button-blue"
                role="menuitem"
            >Similar Surgeons</a>

            <add-to-project
                v-if="modalOpen"
                :resource="resource"
                v-on:hide="hideAddToProjectModal"
            ></add-to-project>
        </div>
        <div class="flex space-x-2 md:hidden">
            <button
                v-if="isFavoriteable"
                @click="toggleFavorite"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-8 h-8"
                    :class="{'text-yellow-500 fill-current stroke-0': modelIsFavorite, 'text-gray-300 hover:text-yellow-500': !modelIsFavorite}"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="1"
                >
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                </svg>
            </button>
            <button class="tw-simple-button" @click="toggleMobileMenu">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 text-gray-500">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z" />
                </svg>
                Actions
            </button>
            <transition
                enter-active-class="transition duration-100 ease-out transform"
                enter-class="scale-95 opacity-0"
                enter-to-class="scale-100 opacity-100"
                leave-active-class="transition duration-75 ease-in transform"
                leave-class="scale-100 opacity-100"
                leave-to-class="scale-95 opacity-0"
              >
              <div
                  v-show="mobileMenuOpen"
                  v-click-outside="closeMobileMenu"
                  v-esc="closeMobileMenu"
                  class="absolute top-0 right-0 w-56 py-1 mt-2 origin-bottom bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5"
                  role="menu"
                  aria-orientation="vertical"
                  aria-hidden="true"
                  aria-labelledby="mobile-menu"
                >
                  <div class="py-1">
                      <a
                        v-if="canAddNotes"
                            @click="addNote"
                            href="#notes_files"
                            class="block px-4 py-2 text-sm leading-6 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100"
                            role="menuitem"
                        >Add Note</a>
                        <a
                            v-if="canAddToProject"
                            @click="showModal"
                            class="block px-4 py-2 text-sm leading-6 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100"
                            role="menuitem"
                            style="margin-bottom: 0px;"
                        >Add to Project</a>
                        <a
                            v-if="canEdit && editRoute"
                            :href="editRoute"
                            class="block px-4 py-2 text-sm leading-6 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100"
                            role="menuitem"
                        >Edit</a>
                        <a
                            v-if="hasSimilarity"
                            :href="similarityRoute"
                            class="block px-4 py-2 text-sm leading-6 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100"
                            role="menuitem"
                        >Similar Surgeons</a>
                  </div>
                </div>

            </transition>
        </div>
    </div>
</template>

<script>
import AddToProject from './AddToProject';
import ClickOutside from 'vue-click-outside';
export default {
    name: 'ActionButtons',
    components: {AddToProject},
    directives: {
      ClickOutside,
    },
    props: {
        resource: {
            type: [Array, Object],
            required: true,
        },
        canEdit: {
            type: Boolean,
            required: false,
            default: false,
        },
        editRoute: {
            type: String,
            required: false,
            default: null,
        },
        similarityRoute: {
            type: String,
            required: false,
            default: null,
        },
        canAddNotes: {
            type: Boolean,
            default: false,
        },
        canAddToProject: {
            type: Boolean,
            required: false,
            default: false,
        },
        isFavoriteable: {
            type: Boolean,
            required: false,
            default: false,
        },
        isFavorite: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data () {
        return {
            modalOpen:  false,
            modelIsFavorite: this.isFavorite,
            mobileMenuOpen: false,
        };
    },
    listeners: {
        'close-project-add-modal' () {
            this.hideAddToProjectModal();
        },
    },
    computed: {
        hasSimilarity() {
            return this.similarityRoute != null;
        }
    },
    methods: {
        showModal: function () {
            this.modalOpen = !this.modalOpen;
        },
        hideAddToProjectModal: function () {
            this.modalOpen = false;
        },
        addNote: function () {
            OSPEvent.$emit('open-note-add-modal');
        },
        toggleFavorite: function() {
            if (! this.isFavoriteable) {
                return;
            }

            if (! this.modelIsFavorite) {
                axios.get(this.route('surgeons.add-favorite', {surgeon: this.resource.id}))
                this.modelIsFavorite = true
            } else {
                axios.get(this.route('surgeons.remove-favorite', {surgeon: this.resource.id}))
                this.modelIsFavorite = false
            }
        },
        toggleMobileMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen;
        },
        closeMobileMenu()
        {
            this.mobileMenuOpen = false;
        }
    },
};
</script>
